import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14fa5f8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-3" }


import SpinnerLoader from './SpinnerLoader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  props: { zIndex: { type: Number, required: true } },
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "backdrop",
      style: _normalizeStyle({zIndex:(__props.zIndex ?? 2) - 1})
    }, null, 4),
    _createElementVNode("div", {
      style: _normalizeStyle({ zIndex: __props.zIndex}),
      class: "loader"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SpinnerLoader)
      ])
    ], 4)
  ], 64))
}
}

})